// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"5e6c93e8","145":"e3429c19","148":"2e5b2039","303":"b1c16025","338":"2457295d","675":"776939eb"}[chunkId] + ".chunk.js";
};